import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { FiFile } from 'react-icons/fi'

import Yup from '../../../../../services/yup'
import { api, authHeaders } from '../../../../../services/api'
import ibge from '../../../../../services/ibge'

import { downloadRelatorioJasper } from '../../../../../util/file'

import {
    Button, Select, Calendar
} from '../../../../../components/Form'
import Spinner from '../../../../../components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeDayGif from '../../../../../assets/images/gifs/periodo-dias.gif'
import rangeMonthGif from '../../../../../assets/images/gifs/periodo-mes.gif'

const initialValues = {
    cidade: '',
    competencia: '',
    instituicao: '',
    'tipo-associado': '',
    'grupo-associado': '',
    'data-nascimento': '',
    aniversario: ''
}

const validation = Yup.object().shape({
    cidade: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    competencia: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    instituicao: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    'tipo-associado': Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    'grupo-associado': Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    'data-nascimento': Yup.string().nullable(),
    aniversario: Yup.string().nullable()
})

const nomeRelatorio = 'Relatório Quites com o Plano de Saúde'

export default function (props) {
    const [cidades, setCidades] = useState([])
    const [instituicoes, setInstituicoes] = useState([])

    useEffect(() => {
        async function loadCidades() {
            const { data } = await ibge.get('estados/PA/municipios')

            setCidades(data.map(({ nome }) => nome).sort())
        }

        loadCidades()
    }, [])

    useEffect(() => {
        async function loadInstituicoes() {
            const response = await api.get('instituicao')

            setInstituicoes(response)
        }

        loadInstituicoes()
    }, [])

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const {
            cidade,
            'data-nascimento': nascimento,
            aniversario,
            competencia,
            instituicao,
            'tipo-associado': tipoAssociado,
            'grupo-associado': grupoAssociado
        } = values

        const compInicio = competencia ? competencia[0] : null
        const compFim = competencia ? competencia[1] : null
        const nascimentoInicio = nascimento ? nascimento[0] : null
        const nascimentoFim = nascimento ? nascimento[1] : null
        const aniversarioInicio = aniversario ? aniversario[0] : null
        const aniversarioFim = aniversario ? aniversario[1] : null

        let filtros = ''

        if (tipoAssociado) {
            filtros += `Médicos: ${tipoAssociado.label}, `
        }

        if (instituicao) {
            filtros += `Instituição: ${instituicao.label}, `
        }

        if (nascimentoInicio) {
            filtros += `Data nasc.: ${format(new Date(nascimentoInicio), 'dd/MM/yyyy')} a ${nascimentoFim !== null ? format(new Date(nascimentoFim), 'dd/MM/yyyy') : format(new Date(nascimentoInicio), 'dd/MM/yyyy')}, `
        }

        if (aniversarioInicio) {
            filtros += `Aniversário: ${format(new Date(aniversarioInicio), 'dd/MM/yyyy')} a ${aniversarioFim !== null ? format(new Date(aniversarioFim), 'dd/MM/yyyy') : format(new Date(aniversarioInicio), 'dd/MM/yyyy')}, `
        }

        if (cidade) {
            filtros += `Cidade: ${cidade.label}, `
        }

        if (grupoAssociado) {
            filtros += `Médicos: ${grupoAssociado.label}, `
        }

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioPlanodeSaudeQuites',
                parametros: {
                    cidade: cidade?.value || '',
                    competenciaInicio: compInicio !== null ? format(new Date(compInicio), 'yyyy-MM-dd') : '',
                    competenciaFim: compFim !== null ? format(new Date(compFim), 'yyyy-MM-dd') : compInicio !== null ? format(new Date(compInicio), 'yyyy-MM-dd') : '',
                    dataNascimentoInicio: nascimentoInicio !== null ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : '',
                    dataNascimentoFim: nascimentoFim !== null ? format(new Date(nascimentoFim), 'yyyy-MM-dd') : (nascimentoInicio !== null) ? format(new Date(nascimentoInicio), 'yyyy-MM-dd') : '',
                    dataAniversarioInicio: aniversarioInicio !== null ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : '',
                    dataAniversarioFim: aniversarioFim !== null ? format(new Date(aniversarioFim), 'yyyy-MM-dd') : (aniversarioInicio !== null) ? format(new Date(aniversarioInicio), 'yyyy-MM-dd') : '',
                    instituicao: instituicao?.value || '',
                    tipoAssociado: tipoAssociado?.value || '',
                    grupoAssociado: grupoAssociado?.value || '',
                    filtros: filtros !== '' ? filtros.slice(0, -2) : ''
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, setFieldValue, resetForm
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="competencia"
                            dateFormat="mm/yy"
                            view="month"
                            label="Competência"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeMonthGif}" style="width:300px; height:auto" />`}
                        />

                        <Select
                            name="instituicao"
                            label="Instituição"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={instituicoes.map(instituicao => ({
                                label: `${instituicao.nome_fantasia} ${instituicao.sigla ? `(${instituicao.sigla})` : ''}`,
                                value: instituicao.id
                            }))}
                            containerStyle={{ gridArea: 'f2' }}
                        />

                        <Select
                            name="cidade"
                            label="Cidade"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={cidades.map(cidade => ({
                                label: cidade,
                                value: cidade
                            }))}
                            containerStyle={{ gridArea: 'f3' }}
                        />

                        <Select
                            name="tipo-associado"
                            label="Tipo Associado"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Associado', value: 3 },
                                { label: 'Ex-associado', value: 5 }
                            ]}
                            containerStyle={{ gridArea: 'f4' }}
                        />

                        <Select
                            name="grupo-associado"
                            label="Grupo Associado"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Falecido', value: 3 }
                            ]}
                            containerStyle={{ gridArea: 'f5' }}
                        />

                        <Calendar
                            name="data-nascimento"
                            dateFormat="dd/mm/yy"
                            label="Data de Nascimento"
                            selectionMode="range"
                            maxDate={new Date(new Date().getFullYear() - 14, 11, 31)}
                            yearRange={`${new Date().getFullYear() - 100}:${new Date().getFullYear() - 14}`}
                            containerStyle={{ gridArea: 'f6' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Calendar
                            name="aniversario"
                            dateFormat="dd/mm"
                            label="Data de Aniversário"
                            yearNavigator={false}
                            containerClass="header-without-year"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f7' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
